export const BASE_URL = import.meta.env.VITE_API_URL;

export const AUTH_REFRESH_ENDPOINT = `${BASE_URL}/api/v1/auth/refresh`;

export const USER_PROFILE = `${BASE_URL}/api/v1/users/:identifier`;

export const CATEGORIES_ENDPOINT = `${BASE_URL}/api/v1/categories`;

export const THREAD_CATEGORIES_ENDPOINT = `${BASE_URL}/api/v1/threads/:threadId/categories`;
export const THREAD_CATEGORIES_BATCH_ENDPOINT = `${BASE_URL}/api/v1/threads/categories/batch`;
export const THREAD_CATEGORIES_RENAME_ENDPOINT = `${BASE_URL}/api/v1/threads/categories/rename`;

export const THREAD_SEARCH_ENDPOINT = `${BASE_URL}/api/v1/threads/search`;